import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function CloudOff({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>CloudOff</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.30554 5.86634C6.17449 6.89079 5.42019 8.32359 5.27532 9.9321C3.26908 10.5954 1.82129 12.485 1.82129 14.7142C1.82129 17.4953 4.07586 19.7499 6.857 19.7499H8.97056H8.97059L8.99986 19.75H16.9999C18.1688 19.75 19.2391 19.3277 20.0666 18.6274L19.0006 17.5614C18.449 17.9928 17.7544 18.25 16.9999 18.25H8.99986L8.97594 18.2499V18.2499H8.97059H6.857C4.90428 18.2499 3.32129 16.6669 3.32129 14.7142C3.32129 13.0045 4.53551 11.5767 6.14908 11.2492C6.49935 11.1781 6.75078 10.8697 6.74988 10.5123L6.74986 10.5C6.74986 9.07652 7.37602 7.7993 8.36792 6.92872L7.30554 5.86634ZM19.9423 16.3818C20.1396 15.9625 20.2499 15.4941 20.2499 15C20.2499 13.2051 18.7948 11.75 16.9999 11.75H16.9774C16.7668 11.75 16.5659 11.6614 16.4238 11.506C16.2817 11.3505 16.2116 11.1425 16.2305 10.9327C16.2433 10.7904 16.2499 10.646 16.2499 10.5C16.2499 7.87665 14.1232 5.75 11.4999 5.75C10.8529 5.75 10.2362 5.87934 9.67409 6.11356L8.5494 4.98887C9.42819 4.51741 10.4328 4.25 11.4999 4.25C14.8876 4.25 17.6457 6.94528 17.747 10.3084C20.0154 10.6668 21.7499 12.6308 21.7499 15C21.7499 15.9118 21.4929 16.7636 21.0475 17.487L19.9423 16.3818Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M4 4L20 20"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
